import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../services/localization.service';
import { LocalizationReplacementsModel } from '../models/localization-replacements.model';

@Pipe({
    name: 'localizeList',
    pure: true,
    standalone: false
})
export class LocalizationListPipe implements PipeTransform {

    constructor(public localizationService: LocalizationService) {
    }

    /**
     * Performs a transform operation on a series of localization keys to get the strings for the current language
     */
    transform(items: string[] | any[], args: LocalizationReplacementsModel[] = [], key: string): string[]|any[]  {
        return this.localizationService.transformList(items, args, key);
    }
}
